import { SerializableObject } from '../../common-react/core';

export class AccountUsesNewFlow extends SerializableObject {
	public usesNewFlow: boolean; // true if the account uses the new flow
	public accountId: string; // Guid as string
	public clientId: string; // client id as string
}
